import React from 'react'
import styles from './styles.module.css'
import Colors from '../../colors'

function TextInput({ label, setText, type, value = '', name, error = false , disabled = false, max}) {
  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>{label}</label>
      <input className={`${styles.textInput}`}
        style={{ border: error ? '2px solid red' : Colors.white }}
        type={type ? type : 'text'}
        defaultValue={value}
        name={name}
        max={max}
        onChange={(e) => setText(e.target.value)}
        disabled={disabled} />
    </div>
  )
}

export default TextInput